import React, { LabelHTMLAttributes } from "react";
import { GetLabelPropsOptions } from "downshift";
import classnames from "classnames";

import "./SelectLabel.scss";

interface SelectLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  getLabelProps: (options?: GetLabelPropsOptions) => any;
  ariaLabel?: string;
  value?: string;
}

export const SelectLabel = ({
  getLabelProps,
  ariaLabel,
  value,
}: SelectLabelProps) => {
  return (
    <label
      {...getLabelProps()}
      className={classnames("select__label", {
        "select__label--hidden": !value,
      })}
      aria-label={ariaLabel}
    >
      {value}
    </label>
  );
};
